module.exports = __webpack_public_path__ + "media/assets/avia/search/preloader-7715820e20b9af57769b45bf3bc20470.svg";